import { render, staticRenderFns } from "./ErrorView.vue?vue&type=template&id=b042f8f0&scoped=true&"
import script from "./ErrorView.vue?vue&type=script&lang=js&"
export * from "./ErrorView.vue?vue&type=script&lang=js&"
import style0 from "./ErrorView.scss?vue&type=style&index=0&id=b042f8f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b042f8f0",
  null
  
)

export default component.exports